// Color constants for murine expression explorer

// Group colors for strip plot markers
export const GROUP_COLORS = {
  a20_vitro: '#3498DB',
  a20_vivo: '#E67E22',
  gcb_wt: '#7FB069',
  gcb_bcl2: '#D4A017',
  gcb_ezh2: '#20B2AA',
  p0: '#E74C3C',
  p6: '#8E44AD',
  taz: '#27AE60',
};

// ImmGen reference line colors
export const IMMGEN_COLORS = {
  Fo: '#F39C12',
  'CB(DZ)': '#2E86AB',
  'CC(LZ)': '#27AE60',
  PB: '#800000',
};

// Strip plot marker symbols (Plotly format)
export const GROUP_MARKERS = {
  a20_vitro: { symbol: 'circle', color: GROUP_COLORS.a20_vitro, name: 'A20 vitro (n=2)' },
  a20_vivo: { symbol: 'triangle-up', color: GROUP_COLORS.a20_vivo, name: 'A20 vivo (n=6)' },
  gcb_wt: { symbol: 'hexagon', color: GROUP_COLORS.gcb_wt, name: 'GCB_WT (n=5)' },
  gcb_bcl2: { symbol: 'pentagon', color: GROUP_COLORS.gcb_bcl2, name: 'GCB_BCL2 (n=5)' },
  gcb_ezh2: { symbol: 'hourglass', color: GROUP_COLORS.gcb_ezh2, name: 'GCB_Ezh2 (n=4)' },
  p0: { symbol: 'square', color: GROUP_COLORS.p0, name: 'P0 (n=5)' },
  p6: { symbol: 'diamond', color: GROUP_COLORS.p6, name: 'P6 (n=3)' },
  taz: { symbol: 'star', color: GROUP_COLORS.taz, name: 'P6+Taz (n=3)' },
};

// Sample-to-group mapping
export const SAMPLE_GROUPS = {
  A201: 'a20_vitro',
  A202: 'a20_vitro',
  Veh_4h_r1: 'a20_vivo',
  Veh_4h_r2: 'a20_vivo',
  Veh_4h_r3: 'a20_vivo',
  Veh_8h_r1: 'a20_vivo',
  Veh_8h_r2: 'a20_vivo',
  Veh_8h_r3: 'a20_vivo',
  GCB_WT_r1: 'gcb_wt',
  GCB_WT_r2: 'gcb_wt',
  GCB_WT_r3: 'gcb_wt',
  GCB_WT_r4: 'gcb_wt',
  GCB_WT_r5: 'gcb_wt',
  GCB_BCL2_r1: 'gcb_bcl2',
  GCB_BCL2_r2: 'gcb_bcl2',
  GCB_BCL2_r3: 'gcb_bcl2',
  GCB_BCL2_r4: 'gcb_bcl2',
  GCB_BCL2_r5: 'gcb_bcl2',
  GCB_Ezh2_r1: 'gcb_ezh2',
  GCB_Ezh2_r2: 'gcb_ezh2',
  GCB_Ezh2_r3: 'gcb_ezh2',
  GCB_Ezh2_r4: 'gcb_ezh2',
  GCB_Ezh2BCL2_r1: 'p0',
  GCB_Ezh2BCL2_r2: 'p0',
  GCB_Ezh2BCL2_r3: 'p0',
  GCB_Ezh2BCL2_r4: 'p0',
  GCB_Ezh2BCL2_r5: 'p0',
  tFL_P6_DMSO_r1: 'p6',
  tFL_P6_DMSO_r2: 'p6',
  tFL_P6_DMSO_r3: 'p6',
  tFL_P6_Taz_r1: 'taz',
  tFL_P6_Taz_r2: 'taz',
  tFL_P6_Taz_r3: 'taz',
};

// Group display order for strip plots
export const STRIP_GROUP_ORDER = [
  'a20_vitro', 'a20_vivo',
  'gcb_wt', 'gcb_bcl2', 'gcb_ezh2',
  'p0', 'p6', 'taz',
];
export const STRIP_GROUP_LABELS = [
  'A20\nvitro', 'A20\nvivo',
  'GCB\nWT', 'GCB\nBCL2', 'GCB\nEzh2',
  'P0', 'P6', 'P6+Taz',
];

// Unicode symbols for legend display
export const GROUP_SYMBOLS = {
  a20_vitro: '●',
  a20_vivo: '▲',
  gcb_wt: '⬡',
  gcb_bcl2: '⬠',
  gcb_ezh2: '⧖',
  p0: '■',
  p6: '◆',
  taz: '★',
};

// Column group definitions for toggle control
// Maps group name to column indices in the 12-column layout
export const COLUMN_GROUPS = {
  ImmGen: [0, 1, 2, 3],
  A20: [4, 5],
  'EmBO Genotypes': [6, 7, 8],
  'EmBO Transformed': [9, 10, 11],
};

// Theme colors
export const THEME = {
  bg: '#0f0f1a',
  surface: '#1a1a2e',
  surfaceHover: '#222240',
  border: '#2a2a45',
  text: '#e0e0e0',
  textMuted: '#8888aa',
  accent: '#4a9eff',
  accentDim: '#2a5e9f',
};
